import throttle from 'lodash/throttle';

import { scrollToX } from '@/services/helpers.js';

let animation = null;
let slider;
let slides;

function loadImage(slide) {
  const nextImage = slide.querySelector('.gallery-img');
  if (nextImage) {
    nextImage.style.backgroundImage = 'var(--bg-image-mobile)'; // only used on mobile
  }
}

function addArrows() {
  const arrowClasses = 'absolute top-0 w-14 h-full bg-no-repeat bg-center';
  const prevArrow = document.createElement('div');
  prevArrow.classList.add(...arrowClasses.split(' '), 'left-0', '-ml-2');
  prevArrow.style.backgroundSize = '40px 40px';
  prevArrow.style.backgroundImage = "url('/build/images/room-page/icon-left.png')";

  const nextArrow = document.createElement('div');
  nextArrow.classList.add(...arrowClasses.split(' '), 'right-0', 'rotate-180', 'transform', '-mr-2');
  nextArrow.style.backgroundSize = '40px 40px';
  nextArrow.style.backgroundImage = "url('/build/images/room-page/icon-left.png')";

  slider.parentElement.classList.add('relative', 'overflow-hidden');
  slider.parentElement.appendChild(prevArrow);
  slider.parentElement.appendChild(nextArrow);

  prevArrow.addEventListener('click', () => {
    if (animation) {
      animation.stop();
    }
    const slideWidth = slides[0].offsetWidth;
    let currentSlide = Math.floor(slider.scrollLeft / slideWidth);
    currentSlide -= 1;
    if (currentSlide < 0) {
      slider.classList.remove('snap-mandatory', 'snap-x');
      setTimeout(() => {
        slider.scrollTo({ left: (slides.length - 1) * slides[0].offsetWidth });
        slider.classList.add('snap-mandatory', 'snap-x');
      }, 100);
      return;
    }
    loadImage(slides[currentSlide]);

    slider.classList.remove('snap-mandatory', 'snap-x');
    animation = scrollToX(slider, currentSlide * slides[0].offsetWidth, 2000, 'easeInOutSine', () => {
      slider.classList.add('snap-mandatory', 'snap-x');
      animation = null;
    });
    animation.start();
  });

  nextArrow.addEventListener('click', () => {
    if (animation) {
      animation.stop();
    }
    const slideWidth = slides[0].offsetWidth;
    let currentSlide = Math.ceil(slider.scrollLeft / slideWidth);
    currentSlide += 1;
    if (currentSlide >= slides.length) {
      slider.classList.remove('snap-mandatory', 'snap-x');
      setTimeout(() => {
        slider.scrollTo({ left: 0 });
        slider.classList.add('snap-mandatory', 'snap-x');
      }, 100);
      return;
    }

    slider.classList.remove('snap-mandatory', 'snap-x');
    animation = scrollToX(slider, currentSlide * slides[0].offsetWidth, 2000, 'easeInOutSine', () => {
      slider.classList.add('snap-mandatory', 'snap-x');
      animation = null;
    });
    animation.start();
  });
}

function initSlider() {
  slider.classList.add(...'flex flex-nowrap overflow-x-scroll no-scrollbar overflow-hidden will-change-scroll snap-mandatory snap-x'.split(' '));

  slides.forEach(slide => {
    slide.classList.add(...'snap-always snap-center min-w-full h-full'.split(' '));
    slide.style.display = 'block';
  });

  setTimeout(() => {
    loadImage(slides[1]); // load very next image on mobile
    loadImage(slides[slides.length - 1]);
  }, 1500);
}

function addSliderCounter() {
  const counter = document.createElement('div');
  counter.classList.add('slider-counter', 'absolute', 'bg-black/70', 'font-semibold', 'bottom-0', 'right-0', 'mb-3', 'mr-2', 'text-white', 'text-sm', 'bg-black', 'bg-opacity-50', 'rounded', 'px-2', 'py-1');
  counter.innerText = `1/${slides.length}`;
  counter.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';

  slider.parentElement.appendChild(counter);
  slider.parentElement.classList.add('relative');

  slider.addEventListener('scroll', throttle(() => {
    const slideWidth = slides[0].offsetWidth;
    const currentSlide = Math.round(slider.scrollLeft / slideWidth);
    counter.innerText = `${currentSlide + 1}/${slides.length}`;
  }, 100));
}

function initLazyLoadingImages(view) {
  let currentImage = 0;
  slider.addEventListener('scroll', throttle(() => {
    const slideWidth = slides[0].offsetWidth;
    const currentSlide = Math.round(slider.scrollLeft / slideWidth);

    const nextSlide = currentSlide + 1;

    if (nextSlide < slides.length) {
      loadImage(slides[nextSlide]);
    }
    setTimeout(() => {
      if (nextSlide + 1 < slides.length) {
        loadImage(slides[nextSlide + 1]);
      }
      if (nextSlide - 2 > 0) {
        loadImage(slides[nextSlide - 2]);
      }
    }, 250);

    const isSlideFullyScrolled = (slider.scrollLeft / slideWidth) % 1 === 0;
    if (currentImage !== currentSlide && isSlideFullyScrolled) {
      let eventName = 'room_page_interaction';
      if (view === 'venuePage') {
        eventName = 'venue_page_interaction';
      }
      App.track.event(eventName, {
        section: 'photos',
        element: 'photo_preview',
        element_value: currentSlide,
        interaction: 'change',
      });
      currentImage = currentSlide;
    }
  }, 100));
}

export default function initMobileSlider(view) {
  if (window.innerWidth > 700) {
    return;
  }
  slider = document.querySelector('.gallery-wrapper');
  slides = slider.querySelectorAll('.gallery-container');

  initSlider();
  initLazyLoadingImages(view);
  addSliderCounter();
  addArrows();
}
